import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';
import AutosuggestField from 'components/fields/AutosuggestField';
import CheckboxField from 'components/fields/CheckboxField';

import {
  reassignWorkflowStatus,
  requestFetchWorkflowStatuses,
  requestSearchWorkflowStatuses,
} from 'redux/modules/workflowStatuses';

import { accountLoginFail } from 'redux/modules/account';

import * as validate from 'utils/validate';

import objectDiff from 'utils/objectDiff';

import WorkflowStatusReassignOldWorkflowStatusNameField from './WorkflowStatusReassignOldWorkflowStatusNameField';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues);

    delete normalizedValues['Old Workflow Status Name'];
    delete normalizedValues['New Workflow Status Name'];
    delete normalizedValues['Selected New Workflow Status Name'];

    return normalizedValues;
  };

  return new Promise((resolve, reject) => {
    dispatch(reassignWorkflowStatus({
      values: normalizeValues(values),
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({ _error: err.description });
    });
}

function onChange(values, dispatch, props) {
  if (values['Workflow State ID']
    && values['Selected Workflow State Name'] !== values['Workflow State Name']) {
    dispatch(props.change('Workflow State ID', null));
  }

  if (values['Next Workflow Status ID']
    && values['Selected Next Workflow Status Name'] !== values['Next Workflow Status Name']) {
    dispatch(props.change('Next Workflow Status ID', null));
  }
}

const validateForm = (values) => {
  const errors = {};

  if (!values['Workflow State ID']) {
    errors['Workflow State Name'] = 'Please, select Workflow State from list';
  }

  return errors;
};

const WorkflowStatusReassignDialogForm = ({
  handleSubmit,
  className,
  error,
  change,
  actions,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={6}
      >
        <Field
          id="Old Workflow Status Name"
          name="Old Workflow Status Name"
          label="Old Workflow Status"
          component={WorkflowStatusReassignOldWorkflowStatusNameField}
        />
      </Grid>
      <Grid
        item
        xs={6}
      >
        <Field
          id="New Workflow Status Name"
          name="New Workflow Status Name"
          label="New Workflow Status"
          component={AutosuggestField}
          errorPlacement="top"
          fullWidth
          renderSuggestionContent={suggestion => suggestion.Name}
          textFieldRef={(textFieldRef) => {
            if (textFieldRef) {
              textFieldRef.focus();
            }
          }}
          onSuggestionSelected={(suggestion) => {
            change('New Workflow Status ID', suggestion.ID);
            change('Selected New Workflow Status Name', suggestion.Name);
            return suggestion.Name;
          }}
          fetchSuggestions={({ value, limit, offset }) => (
            value.length > 0
              ? requestSearchWorkflowStatuses({
                filters: [
                  {
                    name: 'Name',
                    operation: 'contains',
                    val: value,
                    case_sensitivity: false,
                  },
                ],
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
              : requestFetchWorkflowStatuses({
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
          )}
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Typography variant="caption">
          *All orders with old status will be changed to new status
        </Typography>
      </Grid>
    </Grid>
  </form>
);

WorkflowStatusReassignDialogForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

WorkflowStatusReassignDialogForm.defaultProps = {
  className: '',
  error: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'reassignWorkflowStatus',
  onSubmit,
  onChange,
  validate: validateForm,
})(withStyles(styles)(WorkflowStatusReassignDialogForm)));



// WEBPACK FOOTER //
// ./src/components/settings/WorkflowStatusReassignDialog/WorkflowStatusReassignDialogForm.js